import { FileExcelOutlined, PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { importDynamicFieldListExcelFile } from '../../../../actions/settings/dynamicFieldList';
import { useAppDispatch } from '../../../../store/ReduxStore';
import { AsyncDispatch } from '../../../../../types/global';

type DynamicFieldListImportModalProps = {
  handleOnCancel: () => void;
  showImportModal: boolean;
  listName: string;
};

const DynamicFieldListImportModal: React.FC<DynamicFieldListImportModalProps> = ({
  handleOnCancel,
  showImportModal,
  listName,
}) => {
  const { t } = useTranslation();
  const dispatch: AsyncDispatch = useAppDispatch();

  const readFile = (file: any) => {
    // @ts-ignore
    dispatch(importDynamicFieldListExcelFile(file, listName));
    handleOnCancel();
  };

  const handleChange = (info: any) => {
    readFile(info.file);
  };

  const renderUploadButton = () => (
    <div data-testid="upload-file">
      <FileExcelOutlined className="background-icon-excel" />
      <div className="flex items-center">
        <PlusOutlined />
        <div className="ml-2">
          {t('common:upload')} {t('common:excel')}
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      width="50%"
      title={`${t('common:import')} ${t('dynamicFieldList:title')}`}
      open={showImportModal}
      onCancel={() => {
        handleOnCancel();
      }}
      footer={null}
      className="settings-import-modal"
    >
      <Upload
        accept=".xlsx"
        listType="picture-card"
        showUploadList={false}
        customRequest={handleChange}
      >
        {renderUploadButton()}
      </Upload>
    </Modal>
  );
};

export default DynamicFieldListImportModal;
